var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { withTheme } from "styled-components";
import Flex from "@irati/ui/src/Flex";
import id from "@irati/utils/id";
import { getDealTileImage } from "@irati/utils/images/getImageSize/getImageSize";
import { CardImage, StyledFlex } from "./styled";
import CardBody from "./CardBody";
var BirthdayBoxCard = function (_a) {
    var metadata = _a.metadata, theme = _a.theme, props = __rest(_a, ["metadata", "theme"]);
    return (React.createElement(StyledFlex, { direction: "column", padding: "0px 0px " + theme.spacing.two + " 0px", margin: "0px 0px " + theme.spacing.two + " 0px" },
        React.createElement(Flex, { margin: "0px 0px " + theme.spacing.two + " 0px" },
            React.createElement(CardImage, { id: id("img-banner", props), src: getDealTileImage(metadata.image) })),
        React.createElement(CardBody, { id: id("card-body", props), title: metadata.title, brandName: metadata.brandName, desc: metadata.desc })));
};
export default withTheme(BirthdayBoxCard);
